/* eslint-disable */
import $ from 'jquery';
import ko from 'knockout';
import PageContext from '@bingads-webui-static-legacy/page-context';
var i18n = window.globalLegacyI18n.get('module/extension/requirejs/i18n!global');
export default function () {
  this.results = ko.observable([]);
  this.errorMessage = ko.observable('');
  this.selectedEntityCount = ko.observable(0);
  this.showButtonBar = ko.observable(true);
  this.showCloseButton = ko.observable(false);
  this.isDisabled = ko.observable(false);
  this.showPreviewButton = ko.observable(true);
  this.ignoreRowSelection = ko.observable(false);
  this.actionButtonText = ko.observable(i18n.getString('BulkEdit_MakeChanges'));
  this.statusText = ko.observable(i18n.getString('BulkEdit_InitialStatus'));
  this.showProgress = ko.observable(false);
  this.isCampaignAdGroupCopyPasteOperation = ko.observable(false);
  this.successCount = ko.observable(0);
  this.totalCount = ko.observable(0);
  this.completePercentage = ko.computed(function () {
    var total = this.totalCount();
    if (total === 0) {
      return '1%';
    }
    var success = this.successCount();
    var error = this.errorCount();
    var completed = Math.floor((success + error) * 100 / total);
    return completed < 1 ? completed + 1 + '%' : completed + '%';
  }, this);
  this.maxInlineErrorCount = 100;
  this.showErrors = ko.observable(false);
  this.showErrorGrid = ko.observable(false);
  this.errorCount = ko.observable(0);
  this.errorCountString = ko.computed(function () {
    return i18n.getString('BulkEdit_InlineError_ErrorCount').replace('{0}', this.errorCount());
  }, this);
  this.completedWithErrorsBulkEditResultsString = ko.observable(i18n.getString('CampaignAdGroupCopyPaste_CompletedWithErrorsText_OldUI').replace('{0}', PageContext.CurrentCustomer.Id).replace('{1}', PageContext.CurrentUser.Id).replace('{2}', PageContext.CurrentCustomer.Id).replace('{3}', PageContext.CurrentAccount.Id));
  this.inlineErrors = ko.observable();
  this.errorCountLinkText = ko.computed(function () {
    if (this.showErrorGrid()) {
      return i18n.getString('BulkEdit_InlineError_HideErrorLink');
    } else {
      var errorCount = this.errorCount() > this.maxInlineErrorCount ? this.maxInlineErrorCount : this.errorCount();
      return i18n.getString('BulkEdit_InlineError_ErrorLink').replace('{0}', errorCount);
    }
  }, this);
  this.showPreview = ko.observable(false);
  this.showCheckBoxes = ko.observable(false);
  this.currentPageChangeCount = ko.observable(0);
  this.changeText = ko.computed(function () {
    if (this.totalCount() === 0) {
      return i18n.getString('BulkEdit_Preview_NoChange');
    } else {
      if (this.currentPageChangeCount() > 0) {
        return i18n.getString('BulkEdit_Preview_SomeChanges').replace('{0}', this.totalCount());
      } else {
        return i18n.getString('BulkEdit_Preview_NoCurrentPageChange').replace('{0}', this.totalCount());
      }
    }
  }, this);
  this.validate = function () {
    return true;
  };
}

